import React, { useContext, useEffect, useState } from "react";
import {
  Paper,
  makeStyles,
  InputBase,
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Backdrop,
  CircularProgress,
  TableContainer,
  Button,
  TextField,
  InputAdornment,
  useTheme,
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import AddIcon from "@material-ui/icons/Add";
import { Pagination } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { getUmbrell } from "../../store/action";
import history from "../../utils/HistoryUtils";
import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";
import { Visibility } from "@material-ui/icons";
import MuiLink from '@mui/material/Link';
import { ThemeContext } from "../../App";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    // overflowX: "auto",
    padding: 20,
    background: theme.palette.background.main
  },
  container: {
    marginTop: "15px",
    maxHeight: "calc(100vh - 260px)",
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
    marginLeft: 0,
    width: "100%",
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(),
      width: "auto",
    },
  },
  searchIcon: {
    width: theme.spacing(6),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  inputInput: {
    paddingTop: theme.spacing(),
    paddingRight: theme.spacing(),
    paddingBottom: theme.spacing(),
    paddingLeft: theme.spacing(1),
    transition: theme.transitions.create("width"),
    width: "100%",
    borderBottom: "1px solid #ccc",
    [theme.breakpoints.up("md")]: {
      width: 200,
    },
  },
  viewBtn: {
    display: "flex",
    alignItems: "center",
  },

  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const ViewUmbrella = ({ match }) => {
  const theme = useTheme();
  const { mode } = useContext(ThemeContext);
  const classes = useStyle();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(1);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name_umbrella");
  const loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
  const history = useHistory();

  const { loading, getUmbrellaItem } = useSelector(
    (state) => state.umbrellaReducer
  );
  const [searchData, setSearchData] = useState({ search: "" });
  const onhandlClick = (id) => {
    history.push(`${match.url}/${id}/detail`);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
    setTimeout(getUmbrell1(value), 2000);
  };

  const getUmbrell1 = (
    pageNo = 1,
    search = "",
    type = order,
    column_name = orderBy
  ) => {
    dispatch(getUmbrell({ pageNo, search, type, column_name }));
  };

  const handleSearchChange = (event) => {
    const d1 = event.target.value;
    if (d1) {
      setTimeout(getUmbrell1(page, d1), 100);
    } else {
      setTimeout(getUmbrell1(page, ""), 100);
    }
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };

  const handleClickSearch = (event, value) => {
    setTimeout(getUmbrell1(page, searchData.search), 1000);
  };

  const handleRequestSort = (
    property,
    setOrder,
    setOrderBy,
    orderBy,
    order
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    getUmbrell1();
  }, [orderBy, order]);
  const navigate = (url) => {
    history.push(url); // or history.replace('/dashboard');
  };

  useEffect(() => {
    document.documentElement.style.setProperty('--bg-color', theme.palette.grey[1000]);
    document.documentElement.style.setProperty('--sticky-header', theme.palette.thead);
    document.documentElement.style.setProperty('--sticky-odd', theme.palette.background.stickyOdd);
    document.documentElement.style.setProperty('--sticky-even', theme.palette.background.stickyEven);
  }, [mode]);

  return (
    <>
      {loading ? (
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        ""
      )}
      <Paper className={`${classes.root} mb-6`}>
        <Box className="mb-5" display="flex" alignItems="center">

          <div className={classes.search}>
            <TextField
              size="small"
              placeholder="Search now..."
              name="search"
              variant="outlined"
              onChange={handleSearchChange}
              onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      style={{
                        color: "#856f6f", // Icon color
                        cursor: "pointer",
                      }}
                      onClick={handleClickSearch}
                    />
                  </InputAdornment>
                ),
              }}
              className="modernSearchField"
            />
          </div>
          {((loginUserInfo?.role === "STAFF" &&
            loginUserInfo?.permissions?.some(p => p.toLowerCase() === "umbrella-company-create")) || (loginUserInfo?.role !== "STAFF")) && (<div className="ml-5">
              <Button color="primary" variant="contained" onClick={() => navigate(`${match.url}/create`)}>
                <AddIcon className="mr-2" />
                Add Umbrella Company
              </Button>
            </div>)}
        </Box>

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={(event, property) => {
                handleRequestSort(
                  property,
                  setOrder,
                  setOrderBy,
                  orderBy,
                  order
                );
              }}
              rowCount={getUmbrellaItem?.data?.data?.length}
              headCells={headCells[0]}
            />

            <TableBody>
              {getUmbrellaItem?.data &&
                getUmbrellaItem?.data.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell scope="row" style={{ color: theme.palette.listItem }}>{index + 1}</TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>
                        <MuiLink
                          component={Link}
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            onhandlClick(row.id);
                          }}
                          className="clickableLink"
                          style={{ color: "#3e81c3" }}
                        >
                          {`${row.name_umbrella}`}
                        </MuiLink>
                      </TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.bank_name}</TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>
                        {row.bank_account_number}
                      </TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.bank_sort_code}</TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>
                        {row.vat > 0 ? row.vat : "-"}
                      </TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.vat_number}</TableCell>
                      {/* <TableCell align="center">
                        {((loginUserInfo?.role === "STAFF" &&
                          loginUserInfo?.permissions?.some(p => p.toLowerCase() === "umbrella-company-view")) || (loginUserInfo?.role !== "STAFF")) && (
                            <Box
                              style={{ cursor: "pointer" }}
                              onClick={() => onhandlClick(row.id)}
                              variant="outlined"
                              size="small"
                            >
                              <Visibility variant="outlined" size="small" />
                            </Box>
                          )}
                      </TableCell> */}
                    </TableRow>
                  );
                })}

              {getUmbrellaItem?.data?.data?.length == 0 && (
                <TableRow>
                  <TableCell scope="row" colSpan="6">
                    <div className="" align="center">
                      Sorry, staff not available!
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Box className="mt-5" display="flex" justifyContent="flex-end">
          <Pagination
            onChange={handleChangePage}
            page={page}
            count={getUmbrellaItem?.data?.last_page}
            showFirstButton
            showLastButton
          />
        </Box>
      </Paper>
    </>
  );
};

export default ViewUmbrella;
